/* eslint-disable @trello/disallow-filenames */
export const PLAIN_LINK_TITLE = '\u200c';
